import { TipoAcesso } from 'graphql/types.generated'
import { tipoAcesso } from 'types/enums'

import { SelectField, SelectFieldProps } from '../../core/SelectField'

type TipoAcessoSelectFieldProps = DistributiveOmit<SelectFieldProps<TipoAcesso>, 'itemToString'>

export function TipoAcessoSelectField(props: TipoAcessoSelectFieldProps) {
  const itemToString = (item: TipoAcesso) => tipoAcesso[item]

  return <SelectField<TipoAcesso> itemToString={itemToString} {...props} />
}
